import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import seoService from "../../services/seo";

const SEO = ({ seo }) => {
  const location = useLocation();
  const path = location.pathname; // Extract the current path
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    const fetchSEOData = async () => {
      if (!seo) {
        // Only fetch data if `seo` prop is not provided
        try {
          const seoResponse = await seoService.get(path);
          setSeoData(seoResponse.data); // Save the response in state
        } catch (error) {
          console.error("Failed to fetch SEO data:", error);
        }
      }
    };

    fetchSEOData();
  }, [path, seo]); // Run only when `path` or `seo` changes

  // Use either the `seo` prop or the fetched `seoData`
  const effectiveSeo = seo || seoData;

  if (!effectiveSeo) {
    // return null; // Return nothing while waiting for data
    return (
      <Helmet>
        <title>Sabine Hospitals</title>
      </Helmet>
    );
  }

  return (
    <Helmet>
      <title>{effectiveSeo.metatitle}</title>
      <meta name="description" content={effectiveSeo.metadescription} />
      <meta name="keywords" content={effectiveSeo.metakeywords?.join(",")} />
    </Helmet>
  );
};

SEO.propTypes = {
  seo: PropTypes.shape({
    metatitle: PropTypes.string,
    metadescription: PropTypes.string,
    metakeywords: PropTypes.string,
  }),
};

SEO.defaultProps = {
  seo: null,
};

export default SEO;
